module.exports = __webpack_public_path__ + "static/media/communityIcon.dd9984b7.svg";